
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'ProductListingCardSkeleton',
  components: {
    ContentLoader,
  },

  props: {
    speed: {
      type: Number,
      required: false,
      default: 0.6,
    },

    uniqueKey: {
      type: String,
      required: false,
      default: 'my-unique-key',
    },

    animate: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
